import { convertToSubcriberDate } from "../../utils/helper";
import { SignatureDisplay } from "./signatureDisplay";
import PropTypes from "prop-types";

export const PressComponent = ({
  recallDetails,
  issueDetails,
  signatures = [],
  isLoadingSignatures = false,
  onImageError,
  imageErrors = {},
  formatDate
}) => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            backgroundColor: "#D5E4F0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            marginTop: "10px"
          }}
        >
          <h3 className="recall-summary">{recallDetails?.recall_title}</h3>

          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{recallDetails?.id}</span>
                <span> Recall ID </span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{convertToSubcriberDate(recallDetails?.created_on)}</span>
                <span>Recall Date</span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{recallDetails?.recalled_by}</span>
                <span>Recalled By</span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{recallDetails?.no_of_units}</span>
                <span>No of Units</span>
              </div>
            </div>
          </div>
        </div>
        {/* Issue Description */}
        {issueDetails?.description && (
          <div className="recall-details-body-item">
            <h2>Issue Description</h2>
            <p>{issueDetails.description}</p>
          </div>
        )}
      </div>

      {/* Issue Attachment */}
      {(() => {
        const attachment = issueDetails?.attachment;
        if (!attachment) {
          return null;
        }

        try {
          const parsedAttachment = JSON.parse(attachment);
          const isAttachment = parsedAttachment?.length > 0;
          if (!isAttachment) {
            return null;
          }
          const attachmentUrl = parsedAttachment[0]?.url;
          const attachmentName = parsedAttachment[0]?.filename;
          return (
            <div className="recall-details-body-item">
              <h2>Attachment</h2>
              <span style={{ display: "flex", alignItems: "center" }}>
                <span>{attachmentName || "Attachment"}</span>
                <a
                  href={attachmentUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    paddingLeft: "10px",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  <i className="fa fa-download"></i>
                </a>
              </span>
            </div>
          );
        } catch (error) {
          console.error('Error parsing attachment:', error);
          return null;
        }
      })()}

      {/* Signatures Section */}
      <div className="recall-details-body-item">
        <h2>Signature</h2>
        <SignatureDisplay
          signatures={signatures}
          isLoading={isLoadingSignatures}
          onImageError={onImageError}
          imageErrors={imageErrors}
          formatDate={formatDate}
        />
      </div>
    </>
  );
};

PressComponent.propTypes = {
  recallDetails: PropTypes.shape({
    recall_title: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    created_on: PropTypes.string,
    recalled_by: PropTypes.string,
    no_of_units: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  issueDetails: PropTypes.shape({
    description: PropTypes.string,
    attachment: PropTypes.string
  }),
  signatures: PropTypes.array,
  isLoadingSignatures: PropTypes.bool,
  onImageError: PropTypes.func,
  imageErrors: PropTypes.object,
  formatDate: PropTypes.func
};

PressComponent.defaultProps = {
  recallDetails: {},
  issueDetails: {},
  signatures: [],
  isLoadingSignatures: false,
  onImageError: () => { },
  imageErrors: {},
  formatDate: (date) => new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
};